import React, { useState, useEffect, CSSProperties, useRef } from 'react';
import { BrowserRouter as Router, Link, Route, Routes, useParams } from "react-router-dom";

import HashLoader from "react-spinners/ClipLoader";
import {Helmet} from "react-helmet";
//import { Helmet, HelmetProvider } from "react-helmet-async";

//import PullToRefresh from 'react-simple-pull-to-refresh';
import {localStorageTTL, getLocalStorage, setLocalStorage} from '../hooks/localStorageWithTTL';
import {util_isObjectEmpty, util_isObjectNotEmpty, util_getPostDataFetchKey} from '../hooks/util';

import '../style.css';
import '../player.css';
// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";

import * as constants from '../constants';

import placeHolder from '../assets/img/placeholder.imageset/placeholder@2x.png';

import ViewPost from './ViewPost';
import CommonComponent from './CommonComponent';
import TopComponent from './TopComponent';
import ErrorBoundary from './ErrorBoundary';
import ExplurgerPageNotFoundMock from './ExplurgerPageNotFoundMock';

// Post_Type  Spread_Type	Post Name        Post_ID
//     0	      0	        Explurged In      44824 / 44827- with media
//     1	      0	        Pictures/Videos   44117/44115
//     2	      0	        Travelling to     
//     3	      0	        Will go to        44110
//     4	      0	        along with        44121/44122
//     5	      0	        Says              44120/44105/44119
//     6	      0	        journey so far    44097/44096/44094/44092/44091
//     7	      0	        Profile Picture   44103
//     8	      0	        Cover Picture     44104
//     9	      0	        Link Preview      44126/44127/44125

// 44210 spreded

// Nigam Kr - 22a9a9b6e3ea868aa64b3e539d4f440e
// Beauty - k76he9z4sjas58qq3c5l3jqgmpw1653371096324


export default function ViewPostMain(props) {

    const [showModal, setShowModal] = useState(true);

    //const { id } = useParams();
    const { dp_link_uri } = useParams();
    const [dataFetchKey, setDataFetchKey] = useState(null);
    const [postData, setPostData] = useState([]);
    const [postCreatorInfo, setPostCreatorInfo] = useState([]);
    const [isActive, setIsActive] = useState(true);
    const [metaTagData, setMetaTagData] = useState({});

    //const {attr_id} = props; 

    //const [userId, setUserId] = useState(null);

    const dontDismissModelHide = useRef(true);

    function handleDataFromChild(data) {
        //console.log("handleDataFromChild:",data);
        setPostCreatorInfo(data);
    }

    var setFetchedPostData = async (postDataReversed) => {
        //console.log("setFetchedPostData ", postDataReversed);

        var User_Status = postDataReversed.data?.User_Status;
        var Block_Status = postDataReversed.data?.Block_Status;

        //console.log("User_Status ", User_Status);
        //console.log("Block_Status ", Block_Status);
        
        // check user blocked/deleted/de-active
        if(
            (User_Status != undefined && User_Status == "1")  //user deleted/deactive
            || 
            (Block_Status != undefined && Block_Status != "0") //user blocked
        ) 
        {
            // do redirect to website/app/app store
            //redirctToAppOrWebsite();
            setPostData([]);
            noProfile();
            return;
        }       
        

        var Creater_Name = postDataReversed.data.User_FirstName;
        var Creater_ProfilePic = postDataReversed.data.User_Wall_ProfilePic;
        // Cover_BG_Color : "#868586"
        var User_Profile_Cover = postDataReversed.data.User_Profile_Cover;
        var Cover_BG_Color = postDataReversed.data.Cover_BG_Color;
        var User_Handle = postDataReversed.data.User_Handle;
        var User_City = postDataReversed.data.User_City;
        var User_Country = postDataReversed.data.User_Country;
        // var Post_Text = decodeURIComponent(post.Post_Text);

        var User_Bio = postDataReversed.data.User_Bio || "";
        User_Bio = (User_Bio=="undefined")?"":User_Bio;        
        //var User_Bio = decodeURIComponent(postDataReversed.data.User_Bio);



        var Level_Img_Icon = postDataReversed.data.Level_Img_Icon;
        var Level_Name = postDataReversed.data.Level_Name;

        var explurgerSummary = postDataReversed.explurgerSummary;
        //console.log("explurgerSummary", explurgerSummary);
        var i,summary;
        var explurgerSummaryData = [];
        for(i=0;i<explurgerSummary.length;i++)
        {
            summary = explurgerSummary[i];
            explurgerSummaryData[summary.Summary_Type] = summary;
        }
        //console.log(explurgerSummary,explurgerSummaryData);

        // Explurge_Msg
        var Post_Count = postDataReversed.data.Post_Count;
        //Post_Count
        var Explurge_Msg = postDataReversed.data.Explurge_Msg;

        // User_Gender : "0" 0:Male,1:Female:,

        var User_Gender = postDataReversed.data.User_Gender;

        var User_Gender_Text = "";
        if(User_Gender == "0")
        {
            User_Gender_Text = "Male";
        }
        else if(User_Gender == "1")
        {
            User_Gender_Text = "Female";
        }

        // Badge_Status
        var Badge_Status = postDataReversed.data.Badge_Status;

        // Profile_Type : "1"
        var Profile_Type = postDataReversed.data.Profile_Type;

        if(Profile_Type == "1") // Business - No Gender
        {
            User_Gender_Text = "";
        }
        
        var Profile_Category = postDataReversed.data.Profile_Category;
        if(Profile_Category==undefined || Profile_Category==null) // Creators - only show Category
        {
            Profile_Category = "";
        }

        if(Profile_Type != "2") // Creators - only show Category
        {
            Profile_Category = "";
        }

        if(Creater_ProfilePic==null || Creater_ProfilePic=="")
            Creater_ProfilePic = placeHolder;

    
        // Followers_Count: "{32} Followers"
        // Following_Count: "{22} Following"

        var Following_Count = postDataReversed.data.Following_Count;
        var Followers_Count = postDataReversed.data.Followers_Count;
        if(Following_Count==null || Following_Count=="")
            Following_Count = "{0} Following";
        if(Followers_Count==null || Followers_Count=="")
            Followers_Count = "{0} Followers";
        //console.log("Following_Count, Followers_Count", Following_Count, Followers_Count);

        
        setPostCreatorInfo({ 
            Creater_Name: Creater_Name, 
            Creater_ProfilePic: Creater_ProfilePic, 
            User_Profile_Cover:User_Profile_Cover,
            Cover_BG_Color:Cover_BG_Color,
            User_Handle:User_Handle,
            User_City:User_City,
            User_Country:User_Country,
            User_Bio:User_Bio,
            //User_Bio2:User_Bio2,
            Level_Img_Icon:Level_Img_Icon,
            Level_Name:Level_Name,
            explurgerSummaryData:explurgerSummaryData,
            Post_Count:Post_Count,
            Explurge_Msg:Explurge_Msg,
            User_Gender_Text:User_Gender_Text,
            Badge_Status:Badge_Status,
            Profile_Type:Profile_Type,
            Followers_Count:Followers_Count,
            Following_Count:Following_Count,
            Profile_Category: Profile_Category
        });

        //setPostData(postDataReversed);

        // postCreatorInfo.Creater_ProfilePic
        // Creater_Name User_Handle
        // postCreatorInfo.User_Bio

        var user_title = constants.APP_TITLE;
        var user_description = constants.APP_DESCRIPTION;
        var user_image = constants.APP_CDN_URL+constants.APP_IMAGE;

        user_title = Creater_Name; // + " @ " + constants.APP_TITLE;

        if(!(!User_Bio || User_Bio.length === 0 ))
        {
            user_description = decodeURIComponent(User_Bio);
        }

        if(!(!Creater_ProfilePic || Creater_ProfilePic.length === 0 ))
        {
            user_image = Creater_ProfilePic;
        }      
        
        // console.log({
        //     "APP_TITLE":user_title,
        //     "APP_DESCRIPTION":user_description,
        //     "APP_IMAGE":user_image
        // });

        // console.log("user_title:",user_title);
        // console.log("user_description:",user_description);
        // console.log("user_image:",user_image);


        // setMetaTagData({
        //     "APP_TITLE":user_title,
        //     "APP_DESCRIPTION":user_description,
        //     "APP_IMAGE":user_image
        // });

        var dl_data = getLocalStorage("DL_Meta_Data");

        var Meta_Title = dl_data?.Meta_Title || user_title;
        var Meta_Image = dl_data?.Meta_Image || user_image;
        var Meta_Description = dl_data?.Meta_Description || user_description; 
        
        if (Meta_Description == undefined || Meta_Description == "undefined" || Meta_Description == "") {
            Meta_Description = constants.APP_DESCRIPTION;
        }        

        setMetaTagData({
            "APP_TITLE":Meta_Title,
            "APP_DESCRIPTION":Meta_Description,
            "APP_IMAGE":Meta_Image
        }); 
        
        // console.log({
        //     "APP_TITLE":Meta_Title,
        //     "APP_DESCRIPTION":Meta_Description,
        //     "APP_IMAGE":Meta_Image
        // });        

        setIsActive(false);  // Loader false
        window.parent.postMessage({ action: "hideLoader" }, "*");

        //localStorageTTL, getLocalStorage, setLocalStorage

        setLocalStorage('profile_data', postDataReversed, localStorageTTL);
        //console.log("setFetchedPostData 2", postDataReversed);
    }    

    function handleDataFromChildCommonComponent(data) {
        dontDismissModelHide.current = data;
    }    

    function handleDataFromChildDontDismissModelHide(data) {        
        dontDismissModelHide.current = data;
    }

    const initialized = useRef(false);

    var getPostDataFetchKeyNew = async () => {
        try {
            //console.log("-------getPostDataFetchKey---------1-");
            //await util_getPostDataFetchKey(dp_link_uri, 2)
            var body = {
                "Deep_Link_URI": constants.APP_DEEP_LINK_BASE_URL + window.location.pathname,
                "RequestType": "1"
            }            

            await fetch(constants.API_BASE_URL + "webviewData", {
                method: 'POST',
                body: JSON.stringify(body),
                //title: title,
                reqId: Math.random().toString(36).slice(2),
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
                mode: "cors", // required in frontend
            })            
            .then((response) => response.json())
            .then((data) => {   
                var d = 0;  
                //console.log("data:",data);  
                // data.status && 
                if(data.code == 200 && data.data != undefined && util_isObjectNotEmpty(data.data))
                {
                    setLocalStorage('Video_Audio_Mute_Msg_data', data.Video_Audio_Mute_Msg, 24 * 60 * 60);
                    var postData = data.data;
                    // console.log("postData:",postData);
                    // // util_isObjectEmpty, util_isObjectNotEmpty
                    // console.log("util_isObjectEmpty:",util_isObjectEmpty(postData));
                    // console.log("util_isObjectNotEmpty:",util_isObjectNotEmpty(postData));
                    // console.log("postData.length:",postData.length);
                    //postData.length
                    //if(postData != undefined && postData != null && postData.length >0)
                    //if(postData.User_TokenKey != undefined && postData.User_TokenKey.length > 0)
                    if(postData.Meta_Data != undefined)
                    {
                        d = 1;
                        //const postDataReversed = postData.reverse();                    
                        //setFetchedPostData(data);
                        setFetchedPostData(postData.Profile_Summary);
                        setPostData(postData);  
                        //setPostData(postDataReversed);                      
                        setIsActive(false);  // Loader false
                        //setDataFetchKey(postData.User_TokenKey);
                        //setLocalStorage('dl_data', postData, localStorageTTL);
                        
                        setLocalStorage('DL_Meta_Data', postData.Meta_Data, 24 * 60 * 60);
                        setLocalStorage('DL_Profile_Summary', postData.Profile_Summary, 24 * 60 * 60);
                        setLocalStorage('DL_Post_List', postData.Post_List, 24 * 60 * 60);                        
                    }
                }   
                if(d == 0)
                {
                    noProfile();
                }                 
            })
            .catch((error) => {
                console.log("getPostDataFetchKey-",error);
                noProfile();
            });
            //console.log("-------getPostDataFetchKey---------2-");

        }
        catch (e) {
            console.log("getPostDataFetchKey-e ", e);
            setPostData([]);
            noProfile();
        }
    }     

    var getPostDataFetchKeyOld = async () => {
        try {
            //console.log("-------getPostDataFetchKey---------1-");
            await util_getPostDataFetchKey(dp_link_uri, 2)
            .then((response) => response.json())
            .then((data) => {   
                var d = 0;  
                //console.log("data:",data);  
        
                if(data.status && data.code == 200 && data.data != undefined && util_isObjectNotEmpty(data.data))
                {
                    var postData = data.data;
                    // console.log("postData:",postData);
                    // // util_isObjectEmpty, util_isObjectNotEmpty
                    // console.log("util_isObjectEmpty:",util_isObjectEmpty(postData));
                    // console.log("util_isObjectNotEmpty:",util_isObjectNotEmpty(postData));
                    // console.log("postData.length:",postData.length);
                    //postData.length
                    //if(postData != undefined && postData != null && postData.length >0)
                    if(postData.User_TokenKey != undefined && postData.User_TokenKey.length > 0)
                    {
                        d = 1;
                        //const postDataReversed = postData.reverse();                    
                        //setFetchedPostData(data);
                        setPostData(data);                        
                        setIsActive(false);  // Loader false
                        setDataFetchKey(postData.User_TokenKey);
                        setLocalStorage('dl_data', postData, localStorageTTL);
                    }
                }   
                if(d == 0)
                {
                    noProfile();
                }                 
            })
            .catch((error) => {
                console.log("getPostDataFetchKey-",error);
                noProfile();
            });
            //console.log("-------getPostDataFetchKey---------2-");

        }
        catch (e) {
            console.log("getPostDataFetchKey-e ", e);
            setPostData([]);
            noProfile();
        }
    } 

    useEffect(() => {
        //console.log("width, height-", width, height);


        setMetaTagData({
            "APP_TITLE":constants.APP_TITLE,
            "APP_DESCRIPTION":constants.APP_DESCRIPTION,
            "APP_IMAGE":constants.APP_IMAGE
        });        
        
    //}, [width, height]);
    }, []);    


    useEffect(() => {

        if (!initialized.current) {
            initialized.current = true; 
            if(dp_link_uri != undefined && dp_link_uri != null)
            {
                //getPostDataFetchKey();
                getPostDataFetchKeyNew();
            }
        }

    }, []);

    var noProfile = async () => {
        setIsActive(false);  // Loader false
        window.parent.postMessage({ action: "hideLoader" }, "*");
    }

    const isUserProfileActive = () => {
        return postData?.Profile_Summary?.data?.User_Status == "0"
    };

    const showPosts = () => {
        // console.log("showPosts",isActive, postData);
        // postCreatorInfo
        //if (isActive && postData)
        //if (isActive) 
        // status : true
        // if(data.status && data.code == 200)
        //if (!isActive && postData && postData.status == true && postData.code == 200)
        if (!isActive && isUserProfileActive() && postData && postData.Meta_Data != undefined)
        {
            return (<>
                <ErrorBoundary fallback={<p>Something went wrong</p>}>
                    <ViewPost attr_id={dataFetchKey} sendDataToParent={handleDataFromChild} sendDataToParentDontDismissModelHide={handleDataFromChildDontDismissModelHide} dontDismissModelHide={dontDismissModelHide} resfreshAllowed="1"></ViewPost>
                </ErrorBoundary>               
            </>);
        }
        return (<></>);
    }

    const noProfileYet = () => {
        if (!isActive && (!isUserProfileActive() || (postData && postData.length==0)))
        {
            return (<>
                <div className='no_explurge_yet row p0 p0170'>
                    {/* <div className='col col-sm-12 p0'>No User</div> */}
                    {/* <div className='col col-sm-12 p0 splashScreen'><img src={splashScreen}></img></div> */}
                    <ExplurgerPageNotFoundMock></ExplurgerPageNotFoundMock>
                </div>
            </>);
        }
        return (<></>);
    }   
    
    const loaderBox = () => {
        if (isActive)
        {
            return (<>
                <div className='loaderbox'>
                    <HashLoader key="mainLoader" className='mainLoader'></HashLoader>
                </div>
                {/* <div className='splashScreen'><img src={splashScreen}></img></div> */}
            </>);
        }
        return (<></>);
    }
    
    /************************************** Start Fix iOS Popup scroll in iphone */

    const handleChildClick_lockScrollNew = () => {
        //console.log("ViewPostMain-handleChildClick_lockScrollNew ");
        //lockScrollNew();
    };

    const handleChildClick_unlockScrollNew = () => {
        //console.log("ViewPostMain-handleChildClick_unlockScrollNew ");
        //unlockScrollNew();
    };

    const handleChildClick_preventTouchScroll = () => {
        //console.log("ViewPostMain-handleChildClick_preventTouchScroll ");
        //preventTouchScroll();
    };

    const handleChildClick_enableTouchBlock = () => {
        //console.log("ViewPostMain-handleChildClick_enableTouchBlock ");
        //enableTouchBlock();
    };

    const handleChildClick_disableTouchBlock = () => {
        //console.log("ViewPostMain-handleChildClick_disableTouchBlock ");
        //disableTouchBlock();
    };
    
    /************************************** End Fix iOS Popup scroll in iphone */

    return (<>
    <div className="container-fluid m0 p0" id="my-container-element">
        <TopComponent></TopComponent>
        <div className="row main_container">
            
            {/* <div className='col-lg-4 col-xl-4 p0'></div> */}
            <div className='col-lg-12 col-xl-12 p0 max428'>

                {/* <PullToRefresh onRefresh={handleRefresh}> */}

 

                    <div className=' scroll-div '>

                        <div className='loader text-center p0170'>
                            {isActive && loaderBox()}
                            {/* {isActive && <HashLoader key="mainLoader" className='mainLoader'></HashLoader>} */}
                        </div>

                        {showPosts()}

                        {noProfileYet()}                        
                    </div>
                {/* </PullToRefresh> */}

			</div>
            {/* <div className='col-lg-4 col-xl-4 p0'></div> */}
		</div>
	</div>

    <CommonComponent postCreatorInfo={postCreatorInfo} sendDataToParent={handleDataFromChildCommonComponent}></CommonComponent>
    <Helmet>
        <title>{metaTagData.APP_TITLE}</title>
        
        <meta name="description" content={metaTagData.APP_DESCRIPTION} />
        <meta name="keywords" content={constants.APP_KEYWORDS} /> 

        <meta property="og:title" content={metaTagData.APP_TITLE} />
        <meta property="og:description" content={metaTagData.APP_DESCRIPTION} />
        <meta property="og:image" content={metaTagData.APP_IMAGE} />        
    </Helmet> 
    </>)
}